<div class="tab-container">
  <mat-tab-group *ngIf="isAdditionalFilterEnabled">
    <mat-tab label="Top Level Filters">
      <ng-template [ngTemplateOutlet]="topFilter"></ng-template>
    </mat-tab>
    <mat-tab label="Advanced Filters">
      <app-advanced-filters
        [loading]="loading"
        [advancedFilterPanels]="advancedFilterPanels"
        [facetData]="facetData"
        [activePanel]="activePanel"
        [cachedSelections]="cachedSelections"
        [facetFilter]="facetFilter"
        [facetCategorySearch]="facetCategorySearch"
        [placeholderValues]="placeholderValues"
        (onKeyUp)="onFacetCategorySearch($event)"
        (onCheckboxOptionChange)="onOptionChange($event)"
        (onAdvancedFilterChange)="onAdvancedFilterChange($event)"
        (onTreePanelExpandChange)="onExpandChange($event)"
        (onTreePanelHierarchyOptionChange)="onHierarchyOptionChange($event)"
        (updateGraph)="updateGraph($event)"
      ></app-advanced-filters>
    </mat-tab>
  </mat-tab-group>
  <ng-container *ngIf="!isAdditionalFilterEnabled">
    <ng-template [ngTemplateOutlet]="topFilter"></ng-template>
  </ng-container>
  <ng-template #topFilter>
    <div id="facet-content" >
      <div id="facet-options-holder">
        <nz-collapse nzExpandIconPosition="'right'">
          <nz-collapse-panel
            *ngFor="let panel of panels"
            class="facet-panel"
            [nzHeader]="panel.name"
            [(nzActive)]="panel.active"
            [nzDisabled]="false"
            (nzActiveChange)="onActiveChange()"
          >
            <app-facet-filter-search
              [facetCategorySearch]="facetCategorySearch"
              [loading]="loading"
              [panel]="panel"
              [activePanel]="activePanel"
              [refreshCurrentPanel]="refreshCurrentPanel"
              [placeholderValues]="placeholderValues"
              (onKeyUp)="onFacetCategorySearch(panel)"
            ></app-facet-filter-search>
            <div class="facet-options-container">
              <ng-container *ngIf="!panel.isTree">
                <app-facet-checkbox-filter
                  [loading]="loading"
                  [panel]="panel"
                  [activePanel]="activePanel"
                  [refreshCurrentPanel]="refreshCurrentPanel"
                  [facetData]="facetData"
                  [cachedSelections]="cachedSelections"
                  [facetFilter]="facetFilter"
                  (onCheckboxOptionChange)="onOptionChange($event)"
                  (onCheckboxSwitchChange)="onSwitchChange($event)"
                ></app-facet-checkbox-filter>
              </ng-container>
              <ng-container *ngIf="panel.isTree">
                
                <app-facet-tree-filter
                  [loading]="loading"
                  [panel]="panel"
                  [activePanel]="activePanel"
                  [refreshCurrentPanel]="refreshCurrentPanel"
                  [facetData]="facetData"
                  [cachedSelections]="cachedSelections"
                  [facetCategorySearch]="facetCategorySearch"
                  (onPanelExpandChange)="onExpandChange($event)"
                  (onPanelHierarchyOptionChange)="onHierarchyOptionChange($event)"
                ></app-facet-tree-filter>
              </ng-container>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>
  </ng-template>
  <!-- <va-tab-group [tabsArray]="tabsArray" *ngIf="tabsArray.length"
    animationDuration="1200ms"
    [contentTemplates]="{'basicFilters': basicFilters, 'advancedFilters': tab2Content}"
  >
    <ng-template #basicFilters>
      This is tab 1 content
    </ng-template>
    <ng-template #advancedFilters>
      This is tab 2 content
    </ng-template>
  </va-tab-group> -->
</div>


